import {Button, Card, css, styled} from '@mui/material';
import {SelectCardListProps} from './types';

const CardButton = styled(Button)`
	border-radius: 4px;
	min-width: auto;
`;

const SelectCardList = styled(Card)<SelectCardListProps>`
	border: 1px solid transparent;
	cursor: pointer;
	height: 68px;

	${({selected, theme}) =>
		selected &&
		css`
			border: 1px solid ${theme.palette.success.main};
		`}
`;

export {CardButton, SelectCardList};
